import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCirclePlus,
  faCircleExclamation,
  faPen,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import ContactForm from "../ContactForm";
import NewContact from "../Modals/NewContact";
import NewCountry from "../Modals/NewCountry";
import axios from "axios";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/slices/userSlice";
// import { Dialog } from "@headlessui/react";
import Loading from "../Loading";
import NetworkError from "../Modals/NetworkError"
import Swal from 'sweetalert2'
import { getUserRoles, hasRole } from "../../utils/roles";
import {
  countryToBranch,
  DEFAULT_COUNTRIES,
  parseCountry,
} from "../../utils/countries";

const emptyContact = {
  name: "",
  description: "",
  Location: "",
  openings_time: "",
  phone_number: "",
  fax: "",
  delivery_time: "",
  additional_fees: 0,
};

function ContactUsPage() {
  const [showError, setShowError] =useState(false)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [saveError, setSaveError] = useState(null);
  const [unsaved, setUnsaved] = useState(false);
  const currentUser = useSelector(selectUser);
  const adminRole = getUserRoles(currentUser);
  const disabled = !hasRole(adminRole, ["DataEntry", "Admin"]);

  const [showModal, setShowModal] = React.useState(false);
  // index in `contacts` of the country being edited, "new" for a new one
  const [countryToEdit, setCountryToEdit] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [values, setValues] = useState(emptyContact);
  const changeHandler = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const updateContacts = (newContacts) => {
    setContacts(newContacts);
    setUnsaved(true);
  };

  const addContact = (e) => {
    // without this the browser submits the form and reloads the page
    e?.preventDefault();
    if (
      values.name !== "" &&
      values.description !== "" &&
      values.Location !== "" &&
      values.openings_time !== "" &&
      values.phone_number !== "" &&
      values.fax !== "" &&
      values.delivery_time !== ""
    ) {
      updateContacts([...contacts, values]);
      setValues(emptyContact);
      setError(null);
      setShowModal(false);
    } else {
      setError("Please fill all required fields");
    }
  };

  const deleteContact = (index) => {
    updateContacts(contacts.filter((contact, i) => i !== index));
  };

  const saveCountry = (country) => {
    const branch = countryToBranch(country);
    updateContacts(
      countryToEdit === "new"
        ? [...contacts, branch]
        : contacts.map((contact, i) => (i === countryToEdit ? branch : contact))
    );
  };

  const loadDefaultCountries = () => {
    updateContacts([...contacts, ...DEFAULT_COUNTRIES.map(countryToBranch)]);
  };

  const fetchContacts = async () => {
    const response = await axios.get(
      `${"https://api.sedihisham.com"}/branches/getallbranches`
    );
    setContacts(Array.isArray(response.data) ? response.data : []);
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  const submitContacts = async () => {
    setLoading(true);
    setSaveError(null);
    await axios
      .post(`${"https://api.sedihisham.com"}/pages/contact_us/create`, {
        locations_arr: contacts.map((contact) => ({
          name: contact.name,
          description: contact.description,
          Location: contact.Location,
          openings_time: contact.openings_time,
          phone_number: contact.phone_number,
          fax: contact.fax,
          delivery_time: contact.delivery_time,
          additional_fees: Number(contact.additional_fees) || 0,
        })),
      })
      .then((response) => {
        setLoading(false);
        setUnsaved(false);
        Swal.fire({
          icon: 'success',
          title: 'Your changes had been saved',
          showConfirmButton: false,
          timer: 1500
        })
      })
      .catch((err) => {
        console.log(err)
        setLoading(false)
        if (err.code==="ERR_NETWORK"){
          setShowError(true)
          setTimeout(() => {
            setShowError(false)
          }, 3000);
        } else {
          const message = err.response?.data?.message;
          setSaveError(
            Array.isArray(message)
              ? message.join(", ")
              : message || "Could not save, please try again."
          );
        }
      });
  };

  const rows = contacts.map((contact, index) => ({
    contact,
    index,
    country: parseCountry(contact),
  }));
  const branchRows = rows.filter((row) => !row.country);
  const countryRows = rows.filter((row) => row.country);

  return (
    <div>
      <p className="text-[#033362] font-[700] text-[16px]">
        Branches in Syria
      </p>
      <div className="divide-y">
        {branchRows.map(({ contact, index }, i) => (
          <ContactForm
            disabled={true}
            contact={contact}
            deleteContact={() => deleteContact(index)}
            key={index}
            index={i}
          />
        ))}
      </div>
      {showModal ? (
        <NewContact
          error={error}
          values={values}
          setValues={setValues}
          changeHandler={changeHandler}
          addContact={addContact}
          setShowModal={setShowModal}
        />
      ) : null}
      <div
        onClick={() => !disabled && setShowModal(true)}
        className="cursor-pointer  flex items-center text-[#0388CC] h-[30px]  text-[13px]"
      >
        <div className="mr-2">Add new branch </div>
        <div className="text-[20px]">
          <FontAwesomeIcon icon={faCirclePlus} />
        </div>
      </div>

      <div className="mt-10 border-t pt-6">
        <p className="text-[#033362] font-[700] text-[16px]">
          Countries — Global presence map
        </p>
        <p className="text-[13px] font-[400] text-[#707070] mt-1">
          The countries shown on the map of the Contact Us page. Add, edit or
          remove a country here, then click Save.
        </p>
        {countryRows.length === 0 ? (
          <div className="mt-4 rounded-lg bg-[#E9F6FD] p-4 text-[14px] font-[400] text-[#033362]">
            The website is still showing its built-in countries (
            {DEFAULT_COUNTRIES.map((country) => country.name_en).join(", ")}).
            Load them here to edit them, remove some or add new ones.
            <div
              onClick={() => !disabled && loadDefaultCountries()}
              className="cursor-pointer mt-3 w-fit rounded-full text-[13px] px-5 py-1 text-[#fff] bg-[#0388CC]"
            >
              Load current countries
            </div>
          </div>
        ) : (
          <table className="mt-4 w-[91%] text-[14px] font-[400]">
            <thead>
              <tr className="text-left text-[#033362]">
                <th className="py-2">Country - AR</th>
                <th>Country - EN</th>
                <th>City</th>
                <th>Location</th>
                <th></th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {countryRows.map(({ country, index }) => (
                <tr key={index}>
                  <td className="py-2" dir="rtl" style={{ textAlign: "left" }}>
                    {country.name_ar}
                    {country.hq && (
                      <span className="ml-2 rounded bg-[#007530] px-2 text-[11px] text-[white]">
                        HQ
                      </span>
                    )}
                  </td>
                  <td>{country.name_en}</td>
                  <td>
                    {[country.city_en, country.city_ar]
                      .filter(Boolean)
                      .join(" / ")}
                  </td>
                  <td className="text-[12px] text-[#707070]">
                    {country.lat}, {country.lng}
                  </td>
                  <td className="text-right whitespace-nowrap">
                    <span
                      onClick={() => !disabled && setCountryToEdit(index)}
                      className="cursor-pointer rounded px-3 py-[2px] mr-2 text-[white] bg-[#0388CC]"
                    >
                      <FontAwesomeIcon icon={faPen} />
                    </span>
                    <span
                      onClick={() => !disabled && deleteContact(index)}
                      className="cursor-pointer rounded px-3 py-[2px] text-[white] bg-[red]"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <div
          onClick={() => !disabled && setCountryToEdit("new")}
          className="cursor-pointer mt-3 flex items-center text-[#0388CC] h-[30px] text-[13px]"
        >
          <div className="mr-2">Add new country </div>
          <div className="text-[20px]">
            <FontAwesomeIcon icon={faCirclePlus} />
          </div>
        </div>
      </div>
      {countryToEdit !== null ? (
        <NewCountry
          country={
            countryToEdit === "new" ? null : parseCountry(contacts[countryToEdit])
          }
          setShowModal={() => setCountryToEdit(null)}
          onSave={saveCountry}
        />
      ) : null}

      {loading && <Loading />}
      {showError ? <NetworkError setShowModal={setShowError} /> : null}
      {saveError ? (
        <p className="text-[14px] font-[400] mt-4 text-[red]">
          <FontAwesomeIcon icon={faCircleExclamation} /> {saveError}
        </p>
      ) : null}
      <div className="flex items-center pb-[10px] float-right mr-[80px] mt-[20px]">
        {unsaved && (
          <div className="text-[13px] font-[400] text-[#cc4125] mr-4">
            You have unsaved changes
          </div>
        )}
        <div
          onClick={() => {
            setUnsaved(false);
            fetchContacts();
          }}
          className="cursor-pointer rounded-full cursor-pointer text-[13px] mr-2 px-6 py-1 text-[#0388CC] bg-[#E9F6FD]"
        >
          Cancel
        </div>
        <div
          onClick={() => !disabled && submitContacts()}
          className="cursor-pointer rounded-full cursor-pointer text-[13px] px-6 py-1 text-[#fff] bg-[#0388CC]"
        >
          Save
        </div>
      </div>
    </div>
  );
}

export default ContactUsPage;
